import "./actor.cb50ae3a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
var $de11c8cd742bcf55$exports = {};
$de11c8cd742bcf55$exports = import.meta.resolve("edaCh");


// start-snippet{displaymode.fitcontainerandfill}
const $14133bdfa337e046$var$game = new $6TXE3.Engine({
    canvasElementId: 'game',
    width: 600,
    height: 400,
    displayMode: $6TXE3.DisplayMode.FitContainerAndFill // highlight-line
});
// end-snippet{displaymode.fitcontainerandfill}
const $14133bdfa337e046$var$playerImage = new $6TXE3.ImageSource((0, (/*@__PURE__*/$parcel$interopDefault($de11c8cd742bcf55$exports))));
const $14133bdfa337e046$var$loader = new $6TXE3.Loader([
    $14133bdfa337e046$var$playerImage
]);
$14133bdfa337e046$var$game.start($14133bdfa337e046$var$loader).then(()=>{
    const actor = new $6TXE3.Actor({
        pos: $14133bdfa337e046$var$game.screen.center
    });
    actor.graphics.use($14133bdfa337e046$var$playerImage.toSprite());
    $14133bdfa337e046$var$game.currentScene.onPreDraw = (ctx)=>{
        $14133bdfa337e046$var$game.screen.contentArea.draw(ctx, $6TXE3.Color.Yellow);
    };
    $14133bdfa337e046$var$game.currentScene.add(actor);
});


//# sourceMappingURL=fitcontainerandfill.fc1960be.js.map
